export default __webpack_public_path__ + "static/media/biz_booking_icon_promotional.7638d4c6.svg";